import { render, staticRenderFns } from "./ListCreateDialog.vue?vue&type=template&id=63d16673&scoped=true"
import script from "./ListCreateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListCreateDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListCreateDialog.vue?vue&type=style&index=0&id=63d16673&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d16673",
  null
  
)

export default component.exports